Vendd.Scripts.load(function () {

    $('.x-control.x-order.x-orderchangeform').each(function (i, wrapper) {
        var $wrapper = $(wrapper);
        var $orderItems = $('[data-container="orderItem"]', $wrapper);
        var $submitButton = $('button[type="button"][data-click="submit"]', $wrapper);
        var cash = $wrapper.data('cash');

        wrapper.items = [];

        $orderItems.each(function (i, item) {
            var $orderItem = $(item);
            var oid = $orderItem.data('id');

            var $checkboxAction = $('.option-action-checkbox', $orderItem);
            var $changeOrderForms = $('.change-order-form', $orderItem);

            var replaceValOpts = {
                replaceWith: {
                    required: 'replaceWith-required'
                },
                returnReason: {
                    required: 'returnReason-required'
                }
            };

            var refundValOpts = {
                refundReason: {
                    required: 'refundReason-required'
                }
            };

            if (cash) {
                refundValOpts['cardnumber'] = {
                    required: 'cardnumber-required'
                };
                refundValOpts['bankName'] = {
                    required: 'bankName-required'
                };
                refundValOpts['ccname'] = {
                    required: 'ccname-required'
                };
            }

            $orderItem.validationEngine({});

            item.validateInit = function () {
                $orderItem.data('validationEngine').destroy();
                if ($checkboxAction.filter(":checked").val() == "replace") {
                    $orderItem.validationEngine(replaceValOpts);
                } else if ($checkboxAction.filter(":checked").val() == "refund") {
                    $orderItem.validationEngine(refundValOpts);
                } else if ($checkboxAction.filter(":checked").val() == "credit-balance") {
                    $orderItem.validationEngine({});
                }
            };

            $checkboxAction.off("change").on("change", function () {
                var targetedForm = $(this).data('target');

                $orderItem.data('validationEngine').reset();

                if ($(this).is(':checked')) {
                    $checkboxAction.filter('[data-target!=' + targetedForm + ']').prop("checked", false);

                    $changeOrderForms.removeClass("shown");
                    $changeOrderForms.filter('[data-target=' + targetedForm + ']').addClass("shown");

                    item.validateInit();
                } else {
                    $changeOrderForms.filter('[data-target=' + targetedForm + ']', $orderItem).removeClass("shown");
                    $orderItem.validationEngine({});
                }
                $submitButton.prop("disabled", $(".option-action-checkbox:checked", $wrapper).length <= 0);
            });

            $('select[data-member="returnReason"], select[data-member="refundReason"]', $orderItem).off("change").on("change", function () {
                var textareaName;

                if ($(this).val() === 'other') {
                    if ($checkboxAction.filter(":checked").val() == "replace") {
                        textareaName = $('textarea[data-member="returnNote"]', $orderItem).attr('name');
                        replaceValOpts[textareaName] = {
                            required: textareaName + '-required'
                        };
                    } else if ($checkboxAction.filter(":checked").val() == "refund") {
                        textareaName = $('textarea[data-member="refundNote"]', $orderItem).attr('name');
                        refundValOpts[textareaName] = {
                            required: textareaName + '-required'
                        };
                    }
                } else {
                    if ($checkboxAction.filter(":checked").val() == "replace") {
                        textareaName = $('textarea[data-member="returnNote"]', $orderItem).attr('name');
                        replaceValOpts = omit(replaceValOpts, textareaName);
                    } else if ($checkboxAction.filter(":checked").val() == "refund") {
                        textareaName = $('textarea[data-member="refundNote"]', $orderItem).attr('name');
                        refundValOpts = omit(refundValOpts, textareaName);
                    }
                }

            });

            $orderItem.on('keyup', 'input[name], textarea[name]', function (e) {
                var fieldName = $(this).attr('name');
                var rfTemp = $orderItem.data('validationEngine');

                rfTemp.validate(fieldName);
            });

            $orderItem.on('change', 'select[name]', function (e) {
                var fieldName = $(this).attr('name');
                var rfTemp = $orderItem.data('validationEngine');

                rfTemp.validate(fieldName);
            });

            item.getValue = function () {

                var defaultOpts = {
                    id: oid,
                    action: undefined,
                    note: undefined,
                    returnReason: undefined,
                    replaceProductItemId: undefined,
                    bankName: undefined,
                    bankHolder: undefined,
                    bankIban: undefined
                };

                if ($checkboxAction.filter(":checked").val() == "replace") {
                    defaultOpts.action = 'replace';
                    defaultOpts.replaceProductItemId = $('[data-member="replaceWith"]', $changeOrderForms).val();

                    defaultOpts.returnReason = $('[data-member="returnReason"]', $changeOrderForms).val();
                    defaultOpts.note = $('[data-member="returnNote"]', $changeOrderForms).val();
                } else if ($checkboxAction.filter(":checked").val() == "refund") {
                    defaultOpts.action = 'refund';

                    defaultOpts.returnReason = $('[data-member="refundReason"]', $changeOrderForms).val();
                    defaultOpts.note = $('[data-member="refundNote"]', $changeOrderForms).val();

                    defaultOpts.bankName = $('[data-member="bankName"]', $changeOrderForms).val();
                    defaultOpts.bankHolder = $('[data-member="ccname"]', $changeOrderForms).val();
                    defaultOpts.bankIban = $('[data-member="cardnumber"]', $changeOrderForms).val();
                }
                else if ($checkboxAction.filter(":checked").val() == "credit-balance") {
                    defaultOpts.action = 'credit-balance';
                }


                return defaultOpts;
            };
        });

        $submitButton.off("click").on("click", function () {
            wrapper.items = [];
            var validate = true;

            $orderItems.each(function (i, orderItem) {
                var $orderItem = $(orderItem);
                if ($('.option-action-checkbox', $orderItem).filter(":checked").length > 0) {
                    var replaceProductItemId = $(".replaceWithSearchText", $orderItem).attr("data-variantid");
                    $("[name='replaceWith']", $orderItem).val(replaceProductItemId);
                    var rf = $orderItem.data('validationEngine');
                    var val = rf.validate();
                    if (val) {
                        validate = validate && true;
                    } else {
                        validate = false;
                    }
                    wrapper.items.push(orderItem.getValue());
                }
            });

            if (wrapper.items.length > 0 && validate) {
                $('.order-items', $wrapper).addClass('x-loading');
                wrapper.submit();
            } else {
                $('html, body').animate({
                    scrollTop: $('.form-row.with-error', $wrapper).first().closest('.change-order-form').offset().top - 50
                }, 600);
            }
        });

        wrapper.submit = function () {
            var resultData = {
                id: $wrapper.data('id'),
                items: wrapper.items
            };

            Vendd.Service.call({
                url: 'EcomService.svc/ChangeOrder',
                data: {
                    data: resultData
                },
                onSuccess: function (res) {
                    if (res.success) {
                        $('[data-section="content"]', $wrapper).hide();
                        $('.js-success', $wrapper).show();
                        $('.js-error', $wrapper).hide();
                    } else {
                        $('.js-success', $wrapper).hide();
                        $('.js-error', $wrapper).show();
                        $('html, body').animate({
                            scrollTop: $('.js-error', $wrapper).offset().top - 50
                        }, 600);
                    }
                    $('.order-items', $wrapper).removeClass('x-loading');
                }
            });
        };
    });


});